import React, { useState, useEffect, useRef } from "react";
import {
  useLocation,
  useNavigate,
  useSearchParams,
  useParams,
} from "react-router-dom";
import "./blogcomponent.css";
import axiosConfig from "../../Service/AxiosConfig";
import useDebouncedValue from "./DeBounce";
import BlogItem from "./BlogItem";
import "./blogcomponent.css";
const BlogComponent = ({ category }) => {
  const [blogCategories, setBlogCategories] = useState([]);
  const [blogItems, setBlogItems] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearchTerm = useDebouncedValue(search, 500);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [page, setPage] = useState(1); // Track current page
  const [next, setNext] = useState(null);
  const navigate = useNavigate();
  const params = useParams();
  const listRef = useRef();

  const GetData = async (page) => {
    if (!next && page !== 1) return;
    try {
      const categoryParam = search
        ? `&category=`
        : category
          ? `&category=${category}`
          : `&category=`;
      const searchParam = `&search=${search || ""}`;
      const blog_response = await axiosConfig.get(
        `/blogapp/blog/?page=${page}&page_size=2${categoryParam}${searchParam}`
      );

      setNext(blog_response.data.next);

      if (page === 1) {
        setBlogItems(blog_response.data.results);
      } else {
        setBlogItems((prevItems) => [
          ...prevItems,
          ...blog_response.data.results,
        ]);
      }
    } catch (error) {
      console.log("Error getting blog data:", error);
    }
  };

  const GetBlogData = async () => {
    try {
      const categories_response = await axiosConfig.get(
        `/blogapp/blogcategory/?page_size=20`
      );
      setBlogCategories(categories_response.data.results);
    } catch (error) {
      console.log("Error getting blog data :", error);
    }
  };

  const handleCategoryClick = (id, title) => {
    setPage(1);
    navigate(`/${title}`);
  };

  useEffect(() => {
    GetData(page);
  }, [page, category, debouncedSearchTerm]);

  useEffect(() => {
    if (!search) {
      GetBlogData();
    }
  }, [search]);

  useEffect(() => {
    const handleScroll = () => {
      if (listRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 5) {
          loadMoreItems();
        }
      }
    };

    listRef.current.addEventListener("scroll", handleScroll);
    return () => {
      if (listRef.current) {
        listRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [listRef, page]);

  const loadMoreItems = () => {
    console.log("Bottom reached, loading more items...");
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <> 
      <div className="container">
        <div className="blog-grid">
          <div
            className="list"
            ref={listRef}
            style={{
              overflowY: "scroll",
              height: "80vh",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              width: "100%",
            }}
          >
            <ul>
              {blogCategories.length > 0 &&
                blogCategories.map((item) => (
                  <li
                    style={
                      params?.seo_url === item.slug
                        ? { color: " #FF9A00" }
                        : null
                    }
                    onClick={() => handleCategoryClick(item.id, item.slug)}
                    key={item.id}
                    className="pointer"
                  >
                    {console.log(params?.seo_url, "slug")}
                    {item.title}
                  </li>
                ))}
            </ul>
            {blogItems.length > 0 &&
              blogItems.map((item) => (
                <BlogItem
                  item={item}
                  params={params?.seo_url}
                  category={category}
                  key={item.id}
                />
              ))}
          </div>
          <div className="more">
            <div>
              <div className="form-group my-4">
                <h5 className="text-recommended">Blog Search:</h5>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Blog Search"
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
              <h5 className="text-recommended">Recommended topics</h5>
              <div className="filters">
                {blogCategories.length > 0 &&
                  blogCategories.map((item) => (
                    <span
                      className="topic"
                      key={item.id}
                      onClick={() => handleCategoryClick(item.id, item.slug)}
                    >
                      {item.title}
                    </span>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default BlogComponent;
